import React, {Component, createRef} from 'react';
import axios from 'axios';

import apiUrl from "../../shared/config";
import {connect} from "react-redux";
import PresetModal from "../UI/Modal/PresetModal/PresetModal";
import GroupList from "../UserProfile/GroupList";
import Select from "react-select";
import * as actionTypes from "../../store/actions/actionTypes";
import UpdatedUserProfile from "../UserProfile/UpdatedUserProfile/UpdatedUserProfile";


class MiscSearchPanel extends Component {

    state = {
        users: [],
        groups: [],
        selectedUser: null,
        selectedGroup: null
    };

    miscSearchModal = createRef();

    source = axios.CancelToken.source();
    _isMounted = false;


    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.miscSearchModal.current && this.props.show) {
            this.miscSearchModal.current.open();
        } else if (this.miscSearchModal.current) {
            this.miscSearchModal.current.close();
        }
    }

    componentDidMount() {
        this._isMounted = true;
        axios.get(apiUrl +'Users/getUsers')
            .then(response => {
                if (this._isMounted) {
                    this.setState({users: response.data});
                }
            })
            .catch(error => {
                if (axios.isCancel(error)) {
                    console.log('Request canceled', error.message);
                } else {
                    console.error("There was an error fetching the list of users:", error);
                }
            });
        axios.get(apiUrl +'Groups/getGroups')
            .then(response => {
                if (this._isMounted) {
                    this.setState({groups: response.data});
                }
            })
            .catch(error => {
                if (axios.isCancel(error)) {
                    console.log('Request canceled', error.message);
                } else {
                    console.error("There was an error fetching the list of groups:", error);
                }
            });
    }


    componentWillUnmount() {
        // cancel pending api calls
        this._isMounted = false;
        this.source.cancel("Component unmounted, request cancelled");
    }

    openUserView = (user_id) => {
        this.setState({selectedUser: user_id})
        this.props.setSelectedUserId(user_id);
    }

    openGroupView = (group) => {
        let params = {
            params: {
                group_id: group.group_id,
                user_id: +this.props.userId,
            }
        }
        axios.get(apiUrl + 'Groups/getGroupMemberStatusById', params)
            .then((response) => {
                group['group_manager'] = response.data.group_manager;
                group['group_user_status'] = response.data.group_user_status;
            }).then(() => this.setState({selectedGroup: group}))
            .catch(err => console.log(err))
    }

    closeMiscSearchPanel = () => {
        this.props.onCloseModal();
        this.resetMiscSearchModal();
    }

    resetMiscSearchModal = () => {
        this.setState({selectedUser: null})
        this.setState({selectedGroup: null})
        this.props.setSelectedUserId(null);
    }

    render() {
        const groupOptions = this.state.groups
            .map( group => ({value: group.group_id, label: group.group_name, color: '#5bb4d5', group: group
            }));
        const group_selector =  (
            <div key={this.state.groups.toString()} style={{paddingBottom: 10}}>
                <h4>Search for a Group:</h4>
                <Select
                    isSearchable
                    options={groupOptions}
                    closeMenuOnSelect={true}
                    placeholder="Select a group to view its information."
                    onChange={(val) => {
                        this.openGroupView(val.group)
                    }}
                />
            </div>
        );

        const userOptions = this.state.users
            .map( user => ({value: user.user_id, label: user.display_name, color: '#5bb4d5', user: user
            }));
        const user_selector =  (
            <div key={this.state.users.toString()} style={{paddingBottom: 10}}>
                <h4>Search for a User:</h4>
                <Select
                    isSearchable
                    options={userOptions}
                    closeMenuOnSelect={true}
                    placeholder="Select a user to view their profile page."
                    onChange={(val) => {
                        this.openUserView(val.value)
                    }}
                />
            </div>
        );


        const search_page_jsx =
            <React.Fragment>
                {user_selector}
                {group_selector}
            </React.Fragment>

        const modal_display = () => {
            if (!this.state.selectedUser && !this.state.selectedGroup) {
                return <PresetModal ref={this.miscSearchModal} onClose={() => this.closeMiscSearchPanel()}>
                    <div style={{width: "600px"}}></div>
                    <div className={'card'} style={{minHeight: 500, marginBottom: 15}}>
                        <h4 className="card-header">User and Group Search</h4>
                        <div className="card-body">
                            <div className="cardText">
                                {search_page_jsx}
                            </div>
                        </div>
                    </div>
                </PresetModal>
            } else if (this.state.selectedUser) {
                return <PresetModal
                    ref={this.miscSearchModal}
                    buttonText='Back to Search'
                    onButtonPress={() => this.resetMiscSearchModal()}
                    onClose={() => this.closeMiscSearchPanel()}
                >
                    <div style={{width: "600px"}}></div>
                    <UpdatedUserProfile modalRef={this.miscSearchModal}
                                        onCloseProp={() => this.closeMiscSearchPanel()}
                                        givePermissions={this.props.userPermissions.give_permissions}/>
                </PresetModal>
            } else if (this.state.selectedGroup) {
                return <PresetModal
                    ref={this.miscSearchModal}
                    buttonText='Back to Search'
                    onButtonPress={() => this.resetMiscSearchModal()}
                    onClose={() => this.closeMiscSearchPanel()}
                >
                    <div style={{width: "600px"}}></div>
                    <GroupList
                        groups={[this.state.selectedGroup]}
                        userId={this.props.userId}
                        selectedUser={this.props.userId}
                        accountId={this.props.accountId}
                        isUserProfileView={false}
                    />
                </PresetModal>
            } else {
                return <PresetModal ref={this.miscSearchModal} />
            }
        }


        return (
            <React.Fragment>{modal_display()}</React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        show: state.modal.misc_search_modal.isOpen
    }
}

const mapDispatchToProps = dispatch => {
    return {
        // onOpenModal: () => dispatch({type: actionTypes.OPEN_MODAL}),
        onCloseModal: () => dispatch({type: actionTypes.CLOSE_MISC_SEARCH_MODAL}),
        setSelectedUserId: (userId) => dispatch({type: actionTypes.SELECT_USER, userId: userId})
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MiscSearchPanel);